import { render, staticRenderFns } from "./inbox-filter-form.vue?vue&type=template&id=0e22e4e7"
import script from "./inbox-filter-form.vue?vue&type=script&lang=js"
export * from "./inbox-filter-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports